export default "{\n    \"emptyText\": \"Cliquez pour sélectionner un établissement\",\n    \"searchPlaceholderText\": \"Rechercher par nom ou adresse\"\n}\n"